import { render } from "./FrivilligeCheckoutContent.vue?vue&type=template&id=3b4aa9ba"
import script from "./FrivilligeCheckoutContent.vue?vue&type=script&lang=js"
export * from "./FrivilligeCheckoutContent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__